export const STACKED_BAR_DEFAULTS = {
  height: 418,
  barWidth: 52,
  barRadius: 4,
  yTickCount: 4,
  // Left: y-axis label column + gap to the plot. Bottom: gap + x label line height.
  margin: { top: 8, right: 0, bottom: 46, left: 38 },
  xLabelOffset: 24,
  axisFontSize: 8,
  axisLetterSpacing: 1,
  tooltipOffset: 8
};

export const TOOLTIP_CARD_STYLE = {
  width: 253,
  padding: "12px 14px",
  borderRadius: "4px"
};
